<template>
<div>
	<!-- <label>Debug: <input type='checkbox' v-model='debug' :value="true"/></label> -->
	<div class="reports-container">
		<div class="found">{{ 'found' | str }} <strong>{{reports.length}}</strong></div>

		<!-- Category Tabs  -->
		<table class="tabs-table">
			<tbody>
			<tr>
				<template v-for="(cat,index) in categories">
					<td class="tab"						
						v-show="reports_count(cat)>0 || debug===true"
						:key="'tab_'+index"
						v-on:click="selectTab(index)"
						v-bind:class="isActiveTabClass(index)">
						{{ cat }} 
						<div class="badge">{{reports_count(cat)}}</div>
					</td>
				</template>
			</tr>
			</tbody>
		</table>

		<!-- Data Table -->
		<SortedTable :values="records" class="reports-table" sort="report_date" dir="desc">
			<thead>
				<tr>
				<template v-for="(field,index) in fields">
					<td :key="'field_'+index" scope="col" class="noLinkie">						
						<SortLink :name="field">{{str(field)}}</SortLink>
					</td>
				</template>
				</tr>
			</thead>

			<tbody slot="body" slot-scope="sort">
				<tr v-for="(rep,rowIndex) in sort.values" :key="rowIndex">

					<td>
						<span role="link" v-on:click="subSearch(rep.reportId)" :data-reportcode="rep.reportCode">{{local_str(rep, 'name')}}</span>
						<div class="brandlabel">{{rep.brand}}</div>
					</td>
					<td style="text-spacing: 1px;">{{rep.date | date }}</td>
					<td style="text-spacing: 1px;">{{rep.modified | datetime }}</td>
					<td>{{local_str(rep, 'type')}}</td>
					<td style="text-align:center;">{{local_str(rep, 'frequency')}}</td>
					<td style="text-align:center;">{{rep.version}}</td>


				</tr>
			</tbody>		
		</SortedTable>

		<button v-if="downloads.length>0" @click="downloadThese">{{str('download')}}</button>
	</div>



</div>
</template>

<script>
import api from '@/lib/ServerApi'

export default {
	props: {
		newSearch: {
			type: Boolean,
			required: true,
		},
		reports: {
			type: Array,
			required: true
		},
		language: {
			type: String,
			required: true
		},
		categories: {
			type: Array,
			required: true
		}
	},
	mounted: function(){
		this.autoTabSelect();
	},

	data: function() {
		return {
			debug: false,

			// we track the index rather than string so that when the language
			// changes the selected category is still valid.
			selectedCategoryIndex: 0,
			downloads: []
		};
	},
	methods: {
		local_str: function(obj, key) {
			return this.$Localization.objStr(obj, key);
		},
		str: function(val) {
			return this.$Localization.str(val);
		},
		selectTab: function(index) {
			this.selectedCategoryIndex = index;
			this.$emit('selectTab')
		},
		isActiveTabClass: function(val) {
			return this.selectedCategoryIndex==val ? 'tab-active' : '';
		},
		download: function(val) {
			api.download(val).then(function(url){
				console.log(url);
				if(url) {
					window.open(url);
				}
			});
		},
		subSearch: function(reportId){
			this.$emit('subSearch',{reportId:reportId});
		},
		autoTabSelect: function() {
			for (var i = 0; i < this.categories.length; i++) {
				if(this.reports_count(this.categories[i])>0) {
					this.selectTab(i);
					break;
				}
			}
		},
		reports_count: function(cat) {
			var count = 0;
			for (var i = 0; i < this.reports.length; i++) {
				if(this.reports[i].category==cat || this.reports[i].category_fr==cat) {
					count++;
				}
			}
			return count;
		}
	},
	computed: {
		reportsForCategory: function() {
			var cat = this.categories[this.selectedCategoryIndex];
			var self = this;
			return this.reports.filter(function(report) {
				return self.$Localization.objStr(report,'category')==cat;
			});
		},
		current_language: function(){
			return this.language
		},
		fields: function(){
			var fields = [
				'report_name',
				'report_date',
				'modified_date',
				'type',
				'frequency',
				'version',
			];
			return fields;
		},
		records: function(){
			var records = [];

			for(let r=0; r<this.reportsForCategory.length; r++){
				var record = this.reportsForCategory[r];
				record['report_name'] = this.local_str(record, 'name');
				record['report_date'] = record.date;
				record['modified_date'] = record.modified;
				record['type'] = this.local_str(record, 'type');
				record['frequency'] = this.local_str(record, 'frequency');
				// record['version'] = record.version;

				records.push(record);
			}

			return records;
		},
		resetTab: function(){
			return this.newSearch;
		}
	},
	watch: {
		reports: function() {
			// if new search select first non-empty tab
			if(this.newSearch) {
				this.autoTabSelect();
			}
		}

	}
}

</script>



<style>
	.found {
		padding: 2px 10px;
		font-size: 0.8em;
	}
	.reports-container {
		/* box-shadow: -1px 1px 10px #eee; */
		/* padding: 5px; */
		/* border: 1px solid #eee; */
		/* border-radius: 5px; */
	}

	th, td {
		text-align: left;
		padding: 10px;
		vertical-align: top
	}

	.reports-table {
		font-size: 0.8em;
		color: #555;
		width: 100%;
		border-collapse: collapse;
		border: 1px solid whitesmoke;
	}

	.reports-table tr:nth-child(even){
		//background-color: whitesmoke;
	}

	.reports-table thead td{
		border-bottom: 1px solid lightgrey;
	}

	.reports-table th {
		border-bottom: 1px solid #777;
	}
	.reports-table td {
		border-top: 1px solid #eee;
	}

	.tabs-table {
		/*margin-top: 10px;*/
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		overflow: hidden;

		font-size: 0.9em;
		/* color: #555; */
		width: 100%;
		border-collapse: collapse;

	}

	.tab {
		cursor: pointer;
		/* background: #eee; */
		color: white;
		background-color: #aaa;
		border-right: 1px solid #ddd;
		border-bottom: 4px solid #ddd;
		text-align: center;
		padding: 12px 0px 8px;
		width: 16%;
		font-size: 0.9em;
		transition: 0.4s;
		position: relative;
	}

	/* Workaround to get the border not to extend past the cell on the right */
	.tab:after {
		content: "";
		position: absolute;
		bottom: -5px;
		right: -1px;
		width: 1px;
		height: 10px;
		background: #ddd;
	}
	.tab:hover{
		border-bottom-color: #888;
	}

	.tab-active {
		color: white;
		font-weight: bold;
		background-color: #636363;
		/*border-top-color: #aaa;*/
		/* border-right-color: #aaa; */
		border-bottom-color:  #666;
	}
	.tab:first-child {
	}
	.tab:last-child {
		border-right: none;
	}

	.noLinkie a{
		text-decoration: none;
		color: #555;
		font-weight: bold;
	}
	.badge {
		position: absolute;
		top: 5px;
		right: 5px;
		font-weight: normal !important;
		font-size: 0.8em; 
		height: 15px;
		min-width: 17px;
		border-radius: 20px;
		/* background: #d6dbe0; */
		background-color: rgb(243, 243, 243);
		/*border: 1px solid #cbcfd4;*/
		color: #5f5d5d;
		padding: 3px 1px 1px 1px;
		text-align: center;
		font-weight: bolder;
		box-shadow: -1px 1px 2px rgba(0,0,0,0.2);
	}
	.brandlabel {
		font-weight: bold;
		/*font-style: italic;*/
		margin-top: 5px;
		color: #aaa;
	}

</style>

<style lang="scss">
@import "@/_variables.scss";

.lexus .brandlabel {
	color: $lexus;
	opacity: 0.6;
}

.lexus .tab-active {
	border-bottom-color:  $lexus;
}


.toyota .brandlabel {
	color: $toyota;
	opacity: 0.6;
}

.toyota .tab-active {
	border-bottom-color:  $toyota;
}
</style>